export enum UserNotificationType {
  ArticleCreated = 'article_created',
  ArticleMention = 'article_mention',
  ArticlePublish = 'article_publish',
  ArticleVersionRestore = 'article_version_restore',
  CommentMention = 'comment_mention',
  ArticleShared = 'article_shared',
}
